import type { challenges as en } from '@/i18n/locales/en/challenges';
import type { Translation } from '@/i18n/types';

/** See `src/i18n/locales/en/challenges.ts`. */
export const challenges: Translation<typeof en> = {
  page: {
    title: 'Meydan Okumalar',
    lead: 'Adım, uyku, antrenman ve daha fazlası için isteğe bağlı liderlik tablosuyla takım meydan okumaları düzenleyin.',
    noCompany: 'Meydan okumalarını görmek için bir şirket seçin.',
    forbidden: 'Bu şirketin meydan okumalarına erişiminiz yok.',
    empty: 'Henüz meydan okuma yok — ilkini oluşturun.',
  },
  counts: {
    active: 'Aktif meydan okumalar',
    draft: 'Taslaklar',
    completed: 'Tamamlanan',
    totalParticipants: 'Toplam katılımcı',
  },
  sections: {
    activePublished: 'Aktif ve yayınlanan',
    draftsCompleted: 'Taslaklar ve tamamlananlar',
  },
  card: {
    type: 'Tür',
    mode: 'Biçim',
    period: 'Dönem',
    goal: 'Hedef',
    reward: 'Ödül',
    participants: 'Katılımcılar',
    engagement: 'Etkileşim',
    completion: 'Tamamlanma',
    leaderboardVisible: 'Liderlik tablosu görünür',
    leaderboardHidden: 'Liderlik tablosu gizli',
  },
  mode: {
    individual: 'Bireysel',
    group: 'Takım',
  },
  status: {
    draft: 'Taslak',
    active: 'Aktif',
    paused: 'Duraklatıldı',
    completed: 'Tamamlandı',
  },
  type: {
    steps: 'Adım',
    sleep: 'Uyku',
    workouts: 'Antrenman',
    meditation: 'Meditasyon',
    custom: 'Özel',
  },
  actions: {
    newChallenge: 'Yeni meydan okuma',
    publish: 'Yayınla',
    pause: 'Duraklat',
    resume: 'Devam ettir',
    finish: 'Bitir',
    duplicate: 'Taslak olarak çoğalt',
    duplicateSuffix: 'kopya',
    viewLeaderboard: 'Liderlik tablosunu görüntüle',
    hideLeaderboard: 'Liderlik tablosunu gizle',
  },
  leaderboard: {
    title: 'Liderlik tablosu',
    empty: 'Henüz katılımcı yok.',
  },
  form: {
    title: 'Yeni meydan okuma',
    submit: 'Meydan okuma oluştur',
    cancel: 'İptal',
    fields: {
      title: 'Başlık',
      description: 'Açıklama',
      type: 'Tür',
      mode: 'Biçim',
      startDate: 'Başlangıç tarihi',
      endDate: 'Bitiş tarihi',
      goalValue: 'Hedef değer',
      unit: 'Birim',
      reward: 'Ödül',
      leaderboardVisible: 'Katılımcılara liderlik tablosunu göster',
    },
    errors: {
      required: 'Bu alan zorunludur.',
      endBeforeStart: 'Bitiş tarihi başlangıç tarihinden önce olamaz.',
    },
  },
};
